import { render, staticRenderFns } from "./SupportedCards.vue?vue&type=template&id=ed1f0c72&scoped=true&"
import script from "./SupportedCards.vue?vue&type=script&lang=js&"
export * from "./SupportedCards.vue?vue&type=script&lang=js&"
import style0 from "./SupportedCards.vue?vue&type=style&index=0&id=ed1f0c72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1f0c72",
  null
  
)

export default component.exports